import { render } from "./DashboardManual.vue?vue&type=template&id=1541f974&scoped=true"
import script from "./DashboardManual.vue?vue&type=script&lang=js"
export * from "./DashboardManual.vue?vue&type=script&lang=js"

import "./DashboardManual.vue?vue&type=style&index=0&id=1541f974&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1541f974"]])

export default __exports__